import React from 'react'
import Navbar from '../Navbar'
import { Helmet } from 'react-helmet-async'
import './Policies.css'

export const RefundPolicy = () => {

    function handleClick() {
        document.getElementById('anchorHome').click()
    }
    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://robustik.com/refund-policy" />
            </Helmet>
            <section className='hero policies '>
                <div className="container">
                    <div className=' hh2 ' data-aos="fade-up" data-aos-delay="200">
                        <span className="">Refund Policy</span>
                    </div>
                </div>
            </section>
            <section className="policies" data-aos="fade-up" data-aos-delay="300">
                <div className="container">
                    <div className="topic">
                        <div className="heading">1. Purpose</div>
                        <div className="content" >
                            <p>This Refund Policy explains the circumstances under which refunds may or may not be available for services purchased from Robustik.</p>
                            <p>This Policy forms part of our Terms & Conditions (RBL-002) and should be read together with any applicable Proposal, Statement of Work (SOW), Master Service Agreement (MSA), Invoice, or other written agreement.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">2. Scope</div>
                        <div className="content">
                            <p>This Policy applies to all products and services offered by Robustik, including but not limited to:</p>
                            <ul>
                                <li>Logo Design.</li>
                                <li>Branding.</li>
                                <li>Website Design.</li>
                                <li>Website Development.</li>
                                <li>E-commerce Development.</li>
                                <li>UI/UX Design.</li>
                                <li>Social Media Marketing.</li>
                                <li>SEO Services.</li>
                                <li>Software Development.</li>
                                <li>SaaS Products.</li>
                                <li>Technical Consulting.</li>
                                <li>Hosting Services.</li>
                                <li>Maintenance Services.</li>
                                <li>Any future digital services offered by Robustik.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">3. Initial Consultation & Initial Concept</div>
                        <div className="content" >
                            <p>3.1 Initial consultations are generally provided without charge unless otherwise agreed.</p>
                            <p>3.2 Where included in the applicable service package, initial concepts or preliminary creative ideas may be provided free of charge.</p>
                            <p>3.3 No payment obligation arises solely from receiving an initial consultation or complimentary concept unless the Client elects to proceed with the Project.</p>
                            <p>3.4 Once the Client approves the concept and authorizes Robustik to commence the Project, this Refund Policy shall apply.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">4. Project Commencement</div>
                        <div className="content" >
                            <p>A Project shall be deemed to have commenced when any of the following occurs:</p>
                            <ul>
                                <li>The Client approves a proposal.</li>
                                <li>The Client provides written authorization.</li>
                                <li>The required advance payment is received.</li>
                                <li>Development, design, research, planning, or production activities begin.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">5. Advance Payment</div>
                        <div className="content" >
                            <p>5.1 Unless otherwise agreed in writing, Projects require a <strong>50% advance payment</strong> before work begins.</p>
                            <p>5.2 The advance payment secures production time, resource allocation, scheduling, planning, research, and project commencement.</p>
                            <p>5.3 Once Project work has commenced, the advance payment becomes <strong>non-refundable</strong>, except where otherwise required by applicable law or expressly agreed in writing by Robustik.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">6. Custom Services</div>
                        <div className="content" >
                            <p>All services provided by Robustik are customized to meet the specific requirements of each Client.</p>
                            <p>Accordingly, customized work generally cannot be resold, reused, or reassigned to another client.</p>
                            <p>For this reason, completed work, partially completed work, production time, design effort, development effort, consulting time, and other professional services are generally non-refundable after work has commenced.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">7. Client Cancellation</div>
                        <div className="content" >
                            <p>7.1 The Client may request cancellation of a Project at any time by providing written notice.</p>
                            <p>7.2 If cancellation occurs before Project work has commenced, Robustik may, at its sole discretion, issue a partial or full refund after deducting any non-recoverable costs already incurred.</p>
                            <p>7.3 If cancellation occurs after Project work has commenced:</p>
                            <ul>
                                <li>The advance payment shall remain non-refundable.</li>
                                <li>Robustik may invoice the Client for additional completed work that exceeds the value of the advance payment.</li>
                                <li>Partially completed Deliverables shall not be transferred unless all applicable outstanding amounts relating to those Deliverables have been paid.</li>
                            </ul>
                            <p>7.4 Any decision to provide a goodwill refund remains entirely at the sole discretion of Robustik and shall not create any precedent or future obligation.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">8. Project Suspension Due to Client Delay</div>
                        <div className="content" >
                            <p>8.1 The Client acknowledges that timely communication is essential for successful Project completion.</p>
                            <p>8.2 If the Client fails to provide required approvals, content, feedback, credentials, or other necessary information, the Project timeline may be extended accordingly.</p>
                            <p>8.3 If the Project remains inactive due to Client inactivity for more than <strong>30 consecutive calendar days</strong>, Robustik may place the Project on hold.</p>
                            <p>8.4 Before work resumes, Robustik may require payment of a reasonable <strong>Project Reactivation Fee</strong>, taking into account factors including:</p>
                            <ul>
                                <li>Project complexity.</li>
                                <li>Time elapsed.</li>
                                <li>Resource reallocation.</li>
                                <li>Technical review.</li>
                                <li>Planning requirements.</li>
                            </ul>
                            <p>8.5 Client delays do not entitle the Client to a refund.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">9. Refund Eligibility</div>
                        <div className="content" >
                            <p>Refund requests are evaluated on a case-by-case basis in accordance with this Policy, our Terms & Conditions (RBL-002), and any applicable written agreement.</p>
                            <p>A refund may be considered only where:</p>
                            <ul>
                                <li>Payment was processed incorrectly.</li>
                                <li>A duplicate payment was received.</li>
                                <li>Robustik is unable to commence the agreed Project due solely to circumstances within Robustik's reasonable control.</li>
                                <li>Applicable law requires a refund.</li>
                            </ul>
                            <p>Except where required by law, refunds remain at the sole discretion of Robustik.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">10. Non-Refundable Items</div>
                        <div className="content" >
                            <p>Unless required by applicable law, the following are non-refundable after purchase, activation, delivery, commencement, or use (as applicable):</p>
                            <ul>
                                <li>Advance payments after Project commencement.</li>
                                <li>Design work already completed.</li>
                                <li>Development work already completed.</li>
                                <li>Consulting services.</li>
                                <li>Research activities.</li>
                                <li>Discovery sessions.</li>
                                <li>Strategy sessions.</li>
                                <li>Project planning.</li>
                                <li>Project management time.</li>
                                <li>Custom development.</li>
                                <li>Custom software.</li>
                                <li>Custom integrations.</li>
                                <li>AI-assisted work prepared specifically for the Client.</li>
                                <li>Website migration services.</li>
                                <li>Configuration services.</li>
                                <li>Emergency support services.</li>
                                <li>Training sessions.</li>
                                <li>Rush delivery fees.</li>
                                <li>Expedited service fees.</li>
                            </ul>
                            <p>The Client remains solely responsible for the legality and ownership of all materials supplied to Robustik.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">11. Refund Request Procedure</div>
                        <div className="content" >
                            <p>Any Client seeking a refund must submit a written refund request to Robustik.</p>
                            <p>Refund requests should be submitted to:</p>
                            <p>Email: <a href="">contact@robustik.com</a></p>
                            <p>The refund request should include, where applicable:</p>
                            <ul>
                                <li>Client's full name.</li>
                                <li>Company or business name.</li>
                                <li>Project name or reference number.</li>
                                <li>Invoice number.</li>
                                <li>Payment date.</li>
                                <li>Amount paid.</li>
                                <li>Amount requested for refund.</li>
                                <li>Reason for requesting the refund.</li>
                                <li>Relevant supporting information or documentation.</li>

                            </ul>
                            <p>Robustik may request additional information where reasonably necessary to evaluate the refund request.</p>
                            <p>Submitting a refund request does not constitute approval or guarantee that a refund will be issued.</p>
                            <p>Refund eligibility remains subject to this Refund Policy, the applicable Statement of Work (SOW), Master Service Agreement (MSA), Proposal, Quotation, and any other applicable Project agreement.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">12. Refund Review</div>
                        <div className="content">
                            <p>Robustik will normally acknowledge a properly submitted refund request within two (2) Business Days.</p>
                            <p>Robustik aims to review and provide a decision regarding an eligible refund request within seven (7) Business Days following receipt of sufficient information to evaluate the request.</p>
                            <p>Complex cases, disputed Deliverables, incomplete information, payment disputes, third-party costs, or other exceptional circumstances may require additional review time.</p>
                            <p>Where additional information is reasonably required, the Client may be contacted before a final determination is made.</p>
                            <p>Refund requests will be assessed based on factors including:</p>
                            <ul>
                                <li>Work already performed.</li>
                                <li>Deliverables already provided.</li>
                                <li>Approved concepts or designs.</li>
                                <li>Project milestones completed.</li>
                                <li>Third-party costs already incurred.</li>
                                <li>Client-approved expenditures.</li>
                                <li>Applicable contractual obligations.</li>
                                <li>The circumstances giving rise to the refund request.</li>
                            </ul>
                            <p>Robustik reserves the right to request additional supporting documentation, proof of payment, identity verification, or other information reasonably necessary to evaluate a refund request before making a final determination.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">13. Approved Refund Processing</div>
                        <div className="content" >
                            <p>Where a refund is approved, Robustik will normally initiate the refund using the original payment method where reasonably available.</p>
                            <p>Where the original payment method cannot reasonably be used, Robustik and the Client may agree upon an alternative refund method.</p>
                            <p>The time required for funds to appear in the Client's account may depend upon:</p>
                            <ul>
                                <li>Payment processors.</li>
                                <li>Banks and financial institutions.</li>
                                <li>Card networks.</li>
                                <li>Currency conversion processes.</li>
                                <li>International payment systems.</li>
                                <li>Authorized billing partners.</li>
                                <li>Other third-party financial service providers.</li>
                            </ul>
                            <p>Robustik shall not be responsible for processing delays caused by banks, payment processors, authorised billing partners, card networks, or other financial institutions outside its reasonable control.</p>
                            <p>Any refund processing fees, transaction fees, currency conversion losses, third-party charges, or non-refundable processing costs may be deducted from the refunded amount where permitted by applicable law and the applicable agreement.</p>
                            <p>Where permitted by applicable law, any approved refund shall constitute the Client's sole and final monetary remedy in respect of the refunded payment unless otherwise agreed in writing or required by law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">14. Payment Disputes & Chargebacks</div>
                        <div className="content" >
                            <p>Clients are encouraged to contact Robustik and make reasonable efforts to resolve any payment dispute before initiating a chargeback or payment reversal.</p>
                            <p>Nothing in this provision prevents a Client from exercising legitimate rights available through their bank, card issuer, payment provider, or applicable law.</p>
                            <p>However, where a chargeback, payment dispute, reversal, or similar claim is initiated in relation to a payment legitimately due for Services performed, work completed, approved milestones, incurred costs, or Deliverables already provided, Robustik reserves the right, to the extent permitted by applicable law, to:</p>
                            <ul>
                                <li>Suspend ongoing Services.</li>
                                <li>Pause Project work.</li>
                                <li>Withhold pending Deliverables.</li>
                                <li>Suspend applicable hosting, maintenance, or support Services under Robustik's control where contractually permitted.</li>
                                <li>Terminate the applicable Agreement where appropriate.</li>
                                <li>Recover outstanding amounts legitimately due.</li>
                                <li>Recover reasonable chargeback fees, administrative expenses, collection costs, or other costs arising directly from the payment dispute where legally recoverable.</li>
                                <li>Preserve relevant Project files, communications, approvals, invoices, acceptance records, and transaction evidence for dispute resolution purposes.</li>
                                <li>Exercise any contractual or legal remedies otherwise available.</li>
                            </ul>
                            <p>Where intellectual property ownership or licensing rights were conditional upon full payment, a reversed, cancelled, successfully disputed, or otherwise unpaid transaction may affect such ownership or licensing rights in accordance with the applicable Agreement.</p>
                            <p>Robustik will not characterise a good-faith payment dispute as fraudulent merely because the Client exercises a lawful dispute or chargeback right.</p>
                            <p>This provision is intended to address abusive, improper, duplicate, or unjustified payment disputes while preserving all mandatory consumer and statutory rights available under applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">15. Third-Party Products & Services</div>
                        <div className="content" >
                            <p>Amounts paid to third parties on behalf of the Client are generally non-refundable.</p>
                            <p>This may include, without limitation:</p>
                            <ul>
                                <li>Domain registrations.</li>
                                <li>Premium domain purchases.</li>
                                <li>Web hosting purchased from third-party providers.</li>
                                <li>Premium plugins.</li>
                                <li>Premium themes.</li>
                                <li>Commercial APIs.</li>
                                <li>SSL certificates purchased separately.</li>
                                <li>Software licenses.</li>
                                <li>Subscription services.</li>
                                <li>Stock images.</li>
                                <li>Stock videos.</li>
                                <li>Paid fonts.</li>
                                <li>Third-party development tools.</li>
                            </ul>
                            <p>Any refund relating to such items shall remain subject to the applicable third-party provider's own refund policy.</p>
                            <p>Where a third-party provider issues a refund directly to the Client, Robustik shall not be required to duplicate or supplement such refund.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">16. Complimentary Hosting</div>
                        <div className="content" >
                            <p>Where complimentary hosting is included within an eligible package:</p>
                            <ul>
                                <li>The complimentary hosting itself has no refundable value.</li>
                                <li>It cannot be exchanged for cash, discounts, credits, or alternative services.</li>
                                <li>Early termination by the Client does not create any entitlement to financial compensation.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">17. Source Code & Deliverables</div>
                        <div className="content" >
                            <p>The Client is not entitled to receive source code, editable design files, administrative credentials, or other final Deliverables until:</p>
                            <ul>
                                <li>Full payment has been received.</li>
                                <li>Any outstanding contractual obligations have been satisfied.</li>
                            </ul>
                            <p>No refund shall arise merely because Deliverables have not yet been transferred due to outstanding payment obligations.</p>
                            <p>Nothing in this Refund Policy shall require Robustik to transfer ownership, source code, editable files, administrative credentials, or other Deliverables before all applicable payment obligations have been satisfied.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">18. Duplicate or Incorrect Payments</div>
                        <div className="content" >
                            <p>Where a duplicate payment or payment processing error has occurred, Robustik will review the matter promptly.</p>
                            <p>If confirmed, the duplicate amount will be refunded using the original payment method where reasonably practicable, subject to applicable payment processor policies and verification requirements.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">19. Refund Processing</div>
                        <div className="content" >
                            <p>19.1 Approved refunds shall be processed using the original payment method whenever reasonably practicable.</p>
                            <p>19.2 Refund processing times may vary depending upon:</p>
                            <ul>
                                <li>Payment processor policies.</li>
                                <li>Banking institutions.</li>
                                <li>International payment networks.</li>
                                <li>Currency conversion procedures.</li>
                                <li>Regulatory verification requirements.</li>
                            </ul>
                            <p>19.3 Robustik cannot guarantee the exact date on which refunded funds will appear in the Client's account.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">20. Currency Exchange & Banking Fees</div>
                        <div className="content" >
                            <p>20.1 Refunds shall generally be issued in the same currency in which payment was originally received.</p>
                            <p>20.2 Robustik shall not be responsible for:</p>
                            <ul>
                                <li>Currency exchange rate fluctuations.</li>
                                <li>Foreign exchange losses.</li>
                                <li>Bank transfer charges.</li>
                                <li>Credit card processing fees.</li>
                                <li>Payment gateway fees.</li>
                                <li>Intermediary banking charges.</li>
                            </ul>
                            <p>Unless such responsibility is expressly required by applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">21. Taxes</div>
                        <div className="content" >
                            <p>21.1 Unless otherwise required by applicable law, taxes, governmental fees, regulatory charges, payment processing fees, and third-party costs already incurred are generally non-refundable.</p>
                            <p>21.2 The Client remains responsible for any taxes applicable within their own jurisdiction.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">22. Force Majeure</div>
                        <div className="content" >
                            <p>Refund obligations shall not arise solely because Project delays occur due to circumstances beyond the reasonable control of Robustik.</p>
                            <p>Such circumstances may include:</p>
                            <ul>
                                <li>Natural disasters.</li>
                                <li>Government restrictions.</li>
                                <li>Internet outages.</li>
                                <li>Cybersecurity incidents.</li>
                                <li>Utility failures.</li>
                                <li>Armed conflict.</li>
                                <li>Civil unrest.</li>
                                <li>Public health emergencies.</li>
                                <li>Third-party service outages.</li>
                            </ul>
                            <p>Where reasonably possible, Robustik will communicate revised timelines and work with the Client in good faith to continue or complete the Project.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">23. Fraud Prevention</div>
                        <div className="content" >
                            <p>Robustik reserves the right to decline or delay any refund request where there are reasonable grounds to believe that:</p>
                            <ul>
                                <li>Fraudulent activity has occurred.</li>
                                <li>Identity verification cannot be completed.</li>
                                <li>Payment was unauthorized.</li>
                                <li>False information has been provided.</li>
                                <li>Abuse of this Refund Policy is suspected.</li>
                            </ul>
                            <p>Where appropriate, additional verification may be requested before processing any refund.</p>
                            <p>Robustik reserves the right to report suspected fraudulent payment activity to the relevant payment processor, financial institution, regulatory authority, or law enforcement agency were permitted or required by applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">24. Policy Updates</div>
                        <div className="content" >
                            <p>Robustik may revise this Refund Policy from time to time to reflect changes in:</p>
                            <ul>
                                <li>Business operations.</li>
                                <li>Services.</li>
                                <li>Legal requirements.</li>
                                <li>Industry standards.</li>
                                <li>Payment processing practices.</li>

                            </ul>
                            <p>The latest version will always be published on our Website.</p>
                            <p>Continued use of our Services following publication of an updated Refund Policy constitutes acceptance of the revised version to the extent permitted by applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">25. Contact Information</div>
                        <div className="content" >
                            <p>Questions regarding this Refund Policy may be directed to:</p>
                            <p><strong>Robustik</strong></p>
                            <p>Email: contact@robustik.com</p>
                            <p>Registered Business Address: To be updated upon company registration.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">26. Governing Law</div>
                        <div className="content" >
                            <p>This Refund Policy shall be governed by and interpreted in accordance with the laws of the <strong>State of Wyoming, United States</strong>, without regard to its conflict of law principles, except where mandatory consumer protection laws require otherwise.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">27. Severability</div>
                        <div className="content" >
                            <p>If any provision of this Refund Policy is held to be unlawful, invalid, or unenforceable, the remaining provisions shall remain in full force and effect to the maximum extent permitted by applicable law.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">28. No Waiver</div>
                        <div className="content" >
                            <p>Failure or delay by Robustik to exercise any right, remedy, or provision under this Refund Policy shall not constitute a waiver of that right or prevent its future enforcement.</p>
                        </div>
                    </div>

                    <div className="topic">
                        <div className="heading">29. Entire Policy</div>
                        <div className="content" >
                            <p>This Refund Policy constitutes the complete Refund Policy of Robustik regarding refund eligibility, processing, and related matters.</p>
                            <p>Nothing in this Policy limits any additional rights, obligations, or remedies contained within the applicable Terms & Conditions, Master Service Agreement (MSA), Statement of Work (SOW), Proposal, Quotation, Invoice, or other legally binding agreement executed between Robustik and the Client.</p>
                        </div>
                    </div>

                </div>
            </section>

        </>
    )
}
